'use client';

import {
  FeatureItem,
  FileTypeConfig,
  LandingFeatures,
  LandingHero,
  LandingUseCases,
} from '../_components';
import { Layers, Palette, Play, Presentation, Ruler } from 'lucide-react';

const pptxConfig: FileTypeConfig = {
  type: 'pptx',
  title: '在线翻译 PPT 幻灯片·保持设计原貌',
  subtitle: '产品发布、国际演示、教学课件的完美搭档',
  description: '每页独立处理保持原始版式设计',
  icon: <Presentation className="w-full h-full" />,
  gradientFrom: '#f97316',
  gradientTo: '#ea580c',
  accentColor: 'orange',
  particleColors: ['#f97316', '#fb923c', '#fdba74'],
  accept: {
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      ['.pptx'],
  },
  stats: {
    users: '60万+',
    accuracy: '99.3%',
    files: '280万+',
  },
};

const pptxFeatures: FeatureItem[] = [
  {
    icon: Palette,
    title: '设计无损',
    description: '母版、主题色、字体样式完整保留',
  },
  {
    icon: Layers,
    title: '图文分离',
    description: '自动识别文本与装饰元素精准翻译',
  },
  {
    icon: Play,
    title: '动画同步',
    description: '进入/退出动画时间轴不受影响',
  },
  {
    icon: Ruler,
    title: '智能字号',
    description: '中英文字号自动调整适配布局',
  },
];

const pptxUseCases = [
  '学术报告',
  '商业路演',
  '产品发布会',
  '培训课件',
  '国际会议',
  '项目答辩',
];

const PptxPage = () => {
  return (
    <div className="w-full">
      <LandingHero config={pptxConfig} />
      <LandingFeatures
        title="PPT 独特价值"
        features={pptxFeatures}
        gradientFrom={pptxConfig.gradientFrom}
        gradientTo={pptxConfig.gradientTo}
      />
      <LandingUseCases
        useCases={pptxUseCases}
        gradientFrom={pptxConfig.gradientFrom}
        gradientTo={pptxConfig.gradientTo}
      />
    </div>
  );
};

export default PptxPage;
